document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    initUpcomingEventsCarousel();
  }, 100);
});

function initUpcomingEventsCarousel() {
  const uecEl = document.querySelector('.upcoming-events-carousel .uec-container');
  if (!uecEl) {
    return;
  }

  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    setTimeout(initUpcomingEventsCarousel, 200);
    return;
  }

  const spaceBetweenMobile = parseInt(uecEl.dataset.gapMobile) || 16;
  const spaceBetweenDesktop = parseInt(uecEl.dataset.gapDesktop) || 24;
  const eventsLimit = parseInt(uecEl.dataset.eventsLimit, 10) || 0;
  
  // Check if swiper wrapper has slides
  const swiperWrapper = document.querySelector('.upcoming-events-carousel .swiper-wrapper');
  const slides = swiperWrapper ? swiperWrapper.querySelectorAll('.swiper-slide') : [];
  
  if (slides.length === 0) {
    return;
  }

  if (swiperWrapper) {
    const eventSlides = Array.from(swiperWrapper.querySelectorAll('.uec-item.swiper-slide'));
    const sortedSlides = eventSlides.sort((a, b) => {
      const aTs = parseInt(a.getAttribute('data-start-ts') || '0', 10);
      const bTs = parseInt(b.getAttribute('data-start-ts') || '0', 10);
      return aTs - bTs;
    });

    sortedSlides.forEach((slide) => swiperWrapper.appendChild(slide));

    if (eventsLimit > 0 && sortedSlides.length > eventsLimit) {
      sortedSlides.slice(eventsLimit).forEach((slide) => slide.remove());
    }
  }
  
  try {
    var uecSwiper = new Swiper('.upcoming-events-carousel .uec-swiper', {
      spaceBetween: spaceBetweenMobile,
      slidesPerView: 1.2,
      grabCursor: true,
      loop: false,
      centeredSlides: false,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        640: {
          spaceBetween: spaceBetweenMobile,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: spaceBetweenDesktop,
          slidesPerView: 2.5,
        },
        1024: {
          spaceBetween: spaceBetweenDesktop,
          slidesPerView: 3.75,
        },
        1600: {
          spaceBetween: spaceBetweenDesktop,
          slidesPerView: 4.5,
        }
      },
      navigation: {
        nextEl: '.upcoming-events-carousel .uec-pagination .swiper-button-next',
        prevEl: '.upcoming-events-carousel .uec-pagination .swiper-button-prev',
      },
      pagination: {
        el: '.upcoming-events-carousel .uec-footer .swiper-pagination',
        clickable: true,
      },
    });
    
  } catch (error) {
    // Silently handle errors
  }
}